module.exports = __webpack_public_path__ + "fonts/fa-brands-400.4019e2ef.woff2";